import Vue from 'vue'

import { selector } from '@/header/config/app'
import { getJsonData } from '@/common/utils/dom'

import { ProductCategory } from '@/model/productCategory'
import Globalnav from '@/header/components/Globalnav.vue'

const productCategories: Array<ProductCategory> = getJsonData(
  selector.globalnav.productCategories
)

const initGlobalnav = () => {
  const mountEl = selector.globalnav.mountEl

  if (!document.querySelector(mountEl)) {
    return
  }

  new Vue({
    render: h => h(Globalnav, { props: { productCategories } })
  }).$mount(mountEl)
}

initGlobalnav()
